import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPromptTextToImage: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="prompt-text-to-image"><path d="M1.75 5.75V3.75H6H10.25V5.75" stroke="currentColor" strokeWidth="1.5"/><path d="M5.99994 3.75V11.25M5.99994 11.25H4M5.99994 11.25H8" stroke="currentColor" strokeWidth="1.5"/><path d="M5.75 15V20.25H20.25V5.75H14" stroke="currentColor" strokeWidth="1.5"/><path d="M20.25 16.5L15.5 11.75L7.5 20.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPromptTextToImage;
